/**
 * Resolve which permission should be checked based on the state of the company when a response for a specific
 * permission is desired
 */
import { useCallback } from "react";

import type { Permission } from "@lib/permissionConstants";

import { resolvePermission } from "@services/permissions/useResolvePermission/resolvePermission";
import { useCompany } from "@services/useCompany";
import { useFeatureOn } from "@services/useFeatureOn";

export const useResolvePermission = () => {
  const { data: company } = useCompany();
  const featureOn = useFeatureOn();

  return useCallback(
    (permission: Permission) => {
      return resolvePermission(company.granular_permissions_opted_in, featureOn, permission);
    },
    [company.granular_permissions_opted_in, featureOn]
  );
};
